import initialState from './initialState';
import * as types from '../actions/actionTypes';
import { AnyAction } from 'redux';

export default function entityReducer(
  state = initialState.entity,
  action: AnyAction
) {
  switch (action.type) {
    case types.LOAD_ENTITY_SUCCESS: {
      return action.payload;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/reducers/entityReducer.tsx